export default __webpack_public_path__ + "static/media/THSarabun-BoldItalic.e88fbea9.ttf";